import React from 'react';
import PropTypes from 'prop-types';
import PlayButton from '../../images/icons/PlayButt.png';

const CoverPhoto = ({ mobileUrl, desktopUrl, togglePopUpVideo, isVideoExist, videoUrl}) => (
  <>
    {(isVideoExist) ? (
      <div
        className='fe-video-overlay-play'
      >
        <button className='fe-play-button' onClick={() => togglePopUpVideo(true, videoUrl)}>
          <img src={PlayButton}/>
        </button>
      </div>
    ) : null}
    <div
      className="fe-cover-photo mobile"
      style={{ backgroundImage: `url(${mobileUrl})` }}
    />
    <div
      className="fe-cover-photo desktop"
      style={{ backgroundImage: `url(${desktopUrl})` }}
    />
  </>
);

CoverPhoto.propTypes = {
  mobileUrl: PropTypes.string.isRequired,
  desktopUrl: PropTypes.string.isRequired,
  togglePopUpVideo: PropTypes.func,
  videoUrl: PropTypes.string,
  isVideoExist: PropTypes.bool
};

export default CoverPhoto;



